import { Card } from 'antd';
import React, { useMemo } from 'react';
import { CompetitorsResults, SectionData } from './types';
import ReportCategoryStatistics from './ReportCategoryStatistics';
import ReportSection from './ReportSection';
import { getCumulatedSectionsScoreData } from './utils';

type Props = {
    url: string;
    categoryName: string;
    sections: Record<string, SectionData>;
    competitorsSections?: Record<string, CompetitorsResults>;
};

export default function ReportCategory({ url, categoryName, sections, competitorsSections }: Props) {
    const sectionEntries = useMemo(() => Object.entries(sections), [sections]);
    const categoryScoreData = useMemo(() => getCumulatedSectionsScoreData(sections), [sections]);

    return (
        <Card
            className="report-card"
            title={categoryName}
            key={categoryName}
            extra={
                <ReportCategoryStatistics
                    score={categoryScoreData.score}
                    passed={categoryScoreData.passed}
                    warning={categoryScoreData.warning}
                    failed={categoryScoreData.failed}
                />
            }
        >
            {sectionEntries.map(([sectionKey, sectionData]) => {
                const competitorsResults = competitorsSections ? competitorsSections[sectionKey] : undefined;

                return (
                    <ReportSection
                        key={sectionKey}
                        sectionKey={sectionKey}
                        url={url}
                        title={sectionData.title}
                        tooltip={sectionData.description}
                        result={sectionData.result}
                        relevance={sectionData.relevance}
                        passRate={sectionData.passRate}
                        competitorsResults={competitorsResults}
                    />
                );
            })}
        </Card>
    );
}
